import Instance from '../../../utils/Axios';

const AdicionarFuncionario = (ydata) => async (dispatch) => {
  const stateToken = localStorage.token;

  if (stateToken) {
    await Instance()
      .post('/obras/registartempos/associarRecurso', { ydata })
      .then(({ data }) => {
        if (stateToken) {
          dispatch({ type: 'POST_UTILIZADOR', payload: data });
        }
      })
      .catch(({ err }) => console.log(err));
  }
};

export default AdicionarFuncionario;
